<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar filter-row" ref="filterBar">
                <el-input size="mini" v-model="formDatas.orderNumber" clearable placeholder="请输入订单编号"
                    style="width: 180px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.acrCode" clearable placeholder="请输入劵码"
                    style="width: 130px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.phoneNumber" clearable placeholder="请输入手机号"
                    style="width: 130px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.skuCode" clearable placeholder="请输入商品SKU" style="width: 130px;"
                    @keyup.enter.native="partserch"></el-input>
                <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch" placeholder="请选择券状态"
                    style="width: 130px;">
                    <el-option label="已撤销" :value="0"></el-option>
                    <el-option label="创建" :value="1"></el-option>
                    <el-option label="第三方导入" :value="2"></el-option>
                    <el-option label="第三方领取" :value="3"></el-option>
                    <el-option label="已核销" :value="4"></el-option>
                    <el-option label="已分账" :value="5"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfwrHandlerStatus" clearable @change="partserch"
                    placeholder="请选择处理状态" style="width: 120px;">
                    <el-option label="待处理" :value="1"></el-option>
                    <el-option label="已处理" :value="2"></el-option>
                    <el-option label="处理失败" :value="3"></el-option>
                </el-select>
                <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
                <el-button type="success" size="mini" icon="el-icon-refresh" @click="handleSync">更新同步</el-button>
                <el-button type="warning" size="mini" @click="Out">导出</el-button>
          </div>
        </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" :checkbox-option="checkboxOption"
                        rowKeyFieldName="arfwrId" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>

        <!-- 修改SKU弹窗 -->
        <el-dialog title="修改扣减SKU" :visible.sync="skuDialogVisible" width="450px">
            <el-form label-width="100px">
                <el-form-item label="商品SKU">
                    <el-input v-model="skuForm.skuCodeNew" placeholder="请输入新的商品SKU"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="skuForm.skuNameNew" placeholder="请输入新的商品名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="skuDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveSku">确定</el-button>
            </span>
        </el-dialog>

        <!-- 执行纠错弹窗 -->
        <el-dialog title="执行纠错操作" :visible.sync="actionDialogVisible" width="450px">
            <el-form label-width="100px">
                <el-form-item label="退款原因">
                    <el-input type="textarea" v-model="actionReason" :rows="4" placeholder="请输入退款原因"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="actionDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="executeAction">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjefRightsFundWrongReplaceList,
    updateAjefRightsFundWrongReplaceSync,
    updateAjefRightsFundWrongReplaceSku,
    updateAjefRightsFundWrongReplaceAction
} from "../../api/api";

export default {
    name: "RightsFundWrongReplace",
    components: {},
    data() {
        return {
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            key: 'arfwrId',
            selectedRowKeysCollection: [],
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                { field: "tradeDate", key: "tradeDate", title: "业务发生日期", width: 120, align: "center" },
                { field: "phoneNumber", key: "phoneNumber", title: "手机号", width: 160, align: "center" },
                { field: "skuCode", key: "skuCode", title: "商品SKU", width: 130, align: "center" },
                { field: "skuName", key: "skuName", title: "商品名称", width: 150, align: "center" },
                { field: "skuCodeNew", key: "skuCodeNew", title: "新SKU", width: 130, align: "center" },
                { field: "skuNameNew", key: "skuNameNew", title: "新商品名称", width: 150, align: "center" },
                { field: "acrCode", key: "acrCode", title: "券码", width: 150, align: "center" },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "券状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            0: { text: '已撤销', type: 'info' },
                            1: { text: '创建', type: '' },
                            2: { text: '第三方导入', type: 'warning' },
                            3: { text: '第三方领取', type: 'warning' },
                            4: { text: '已核销', type: 'success' },
                            5: { text: '已分账', type: 'success' }
                        };
                        const status = statusMap[row.acrStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "arfrIdNew", key: "arfrIdNew", title: "回退记录id", width: 100, align: "center" },
                { field: "arfrIdNewDes", key: "arfrIdNewDes", title: "回退记录", width: 200, align: "center" },
                { field: "arfdIdNew", key: "arfdIdNew", title: "扣减记录id", width: 100, align: "center" },
                { field: "arfdIdNewDes", key: "arfdIdNewDes", title: "扣减记录", width: 200, align: "center" },
                { field: "orderNumber", key: "orderNumber", title: "订单编号", width: 300, align: "center" },
                { field: "operationTime", key: "operationTime", title: "操作时间", width: 160, align: "center" },
                { field: "shopName", key: "shopName", title: "商户全称", width: 180, align: "center" },
                {
                    field: "skuAmount",
                    key: "skuAmount",
                    title: "兑换券金额",
                    width: 100,
                    align: "center"
                },
                {
                    field: "settlementPrice",
                    key: "settlementPrice",
                    title: "结算价格",
                    width: 100,
                    align: "center"
                },
                {
                    field: "actualSettlement",
                    key: "actualSettlement",
                    title: "应结算金额",
                    width: 100,
                    align: "center"
                },
                {
                    field: "priceDifference",
                    key: "priceDifference",
                    title: "差额",
                    width: 100,
                    align: "center"
                },
                { field: "arfwrHandlerTime", key: "arfwrHandlerTime", title: "处理时间", width: 160, align: "center" },
                {
                    field: "arfwrHandlerStatus",
                    key: "arfwrHandlerStatus",
                    title: "处理状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            1: { text: '待处理', type: 'warning' },
                            2: { text: '已处理', type: 'success' },
                            3: { text: '处理失败', type: 'danger' }
                        };
                        const status = statusMap[row.arfwrHandlerStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "arfwrHandlerStatusDes", key: "arfwrHandlerStatusDes", title: "处理状态描述", width: 120, align: "center" },
                {
                    field: "action",
                    key: "action",
                    title: "操作",
                    width: 160,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const buttons = [];
                        // 修改SKU按钮 - 仅待处理状态可用
                        if (row.arfwrHandlerStatus === 1) {
                            buttons.push(h('el-button', {
                                props: { type: 'text', size: 'mini' },
                                style: { color: '#E6A23C', marginRight: '10px' },
                                on: { click: () => this.handleEditSku(row) }
                            }, '修改SKU'));
                            buttons.push(h('el-button', {
                                props: { type: 'text', size: 'mini' },
                                style: { color: '#67C23A' },
                                on: { click: () => this.handleAction(row) }
                            }, '执行'));
                        }
                        return h('div', buttons);
                    },
                },
            ],
            tableData: [],
            formDatas: {
                orderNumber: '',
                phoneNumber: '',
                skuCode: '',
                acrStatus: null,
                arfwrHandlerStatus: null,
                currentPage: 1,
                pageSize: 10,
            },
            // SKU弹窗
            skuDialogVisible: false,
            skuForm: {
                arfwrId: null,
                skuCodeNew: '',
                skuNameNew: ''
            },
            // 执行弹窗
            actionDialogVisible: false,
            actionReason: '',
            currentActionRow: null,
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    deactivated() { },
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        // 重置选中状态（翻页后恢复选中）
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];
            const selectedRowKeysCollection = this.selectedRowKeysCollection;
            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // 全选/取消全选
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        // 单选
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundWrongReplaceList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundWrongReplaceList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                // 搜索时清空选中
                this.selectedRowKeysCollection = [];
                this.checkboxOption.selectedRowKeys = [];
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundWrongReplaceList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        // 导出
        Out() {
            const loading = this.$loading({
                lock: true,
                text: '导出中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const s = qs.stringify(this.formDatas);
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-rights-fund-wrong-replace/exportAjefRightsFundWrongReplace',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then((res) => {
                loading.close();
                if (res.data) {
                    const a = document.createElement('a');
                    const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    const objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '权益基金纠错替换记录.xlsx');
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                    this.$message.success('导出成功');
                }
            }).catch(() => {
                loading.close();
                this.$message.error('导出失败');
            });
        },
        // 更新同步
        handleSync() {
            if (this.selectedRowKeysCollection.length === 0) {
                this.$message.warning('请先选择要同步的数据');
                return;
            }
            this.$confirm('确定要执行更新同步操作吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const arfwrIds = JSON.stringify(this.selectedRowKeysCollection);
                updateAjefRightsFundWrongReplaceSync({ arfwrIds }).then(() => {
                    this.$message.success('同步成功');
                    this.selectedRowKeysCollection = [];
                    this.checkboxOption.selectedRowKeys = [];
                    this.getList();
                }).catch(() => {
                    this.$message.error('同步失败');
                });
            }).catch(() => { });
        },
        // 修改SKU
        handleEditSku(row) {
            this.skuForm = {
                arfwrId: row.arfwrId,
                skuCodeNew: row.skuCodeNew || row.skuCode || '',
                skuNameNew: row.skuNameNew || row.skuName || ''
            };
            this.skuDialogVisible = true;
        },
        saveSku() {
            if (!this.skuForm.skuCodeNew) {
                this.$message.warning('请输入商品SKU');
                return;
            }
            if (!this.skuForm.skuNameNew) {
                this.$message.warning('请输入商品名称');
                return;
            }
            updateAjefRightsFundWrongReplaceSku(this.skuForm).then(() => {
                this.$message.success('修改成功');
                this.skuDialogVisible = false;
                this.getList();
            }).catch(() => {
                this.$message.error('修改失败');
            });
        },
        // 执行纠错
        handleAction(row) {
            this.currentActionRow = row;
            this.actionReason = '客户反悔';
            this.actionDialogVisible = true;
        },
        executeAction() {
            if (!this.actionReason) {
                this.$message.warning('请输入退款原因');
                return;
            }
            updateAjefRightsFundWrongReplaceAction({
                arfwrId: this.currentActionRow.arfwrId,
                reason: this.actionReason
            }).then(() => {
                this.$message.success('执行成功');
                this.actionDialogVisible = false;
                this.getList();
            }).catch(() => {
                this.$message.error('执行失败');
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.filter-row {
    margin: 0 10px;
    width: 98%;
    display: flex;
    padding-left: 20px;
    flex-wrap: wrap;
}

.filter-row>* {
    margin-top: 5px;
    margin-left: 10px;
}

.filter-row>*:first-child {
    margin-left: 0;
}
</style>
